import {all} from "redux-saga/effects";
import {combineReducers} from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import {productsSlice} from "../app/modules/Base/_redux/products/productsSlice";
import {usersSlice} from "../app/modules/Base/_redux/users/usersSlice";
import {branchesSlice} from "../app/modules/Base/_redux/branches/branchesSlice";
import {ordersSlice} from "../app/modules/Sale/_redux/orders/ordersSlice";
import {orderlinesSlice} from "../app/modules/Sale/_redux/orderlines/orderlinesSlice";
import {schedulesSlice} from "../app/modules/Base/_redux/schedules/schedulesSlice";
import {invoicesSlice} from "../app/modules/Accounting/_redux/invoices/InvoicesSlice";
import {noticesSlice} from "../app/modules/Operation/_redux/notices/noticesSlice";
import {investigationsSlice} from "../app/modules/QC/_redux/investigations/investigationsSlice";
import {accessGroupsSlice} from "../app/modules/Base/_redux/accessGroups/accessGroupsSlice";
import {accessesSlice} from "../app/modules/Base/_redux/accesses/accessesSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  products: productsSlice.reducer,
  users: usersSlice.reducer,
  branches: branchesSlice.reducer,
  orders: ordersSlice.reducer,
  orderlines: orderlinesSlice.reducer,
  schedules: schedulesSlice.reducer,
  invoices: invoicesSlice.reducer,
  notices: noticesSlice.reducer,
  investigations: investigationsSlice.reducer,
  accessGroups: accessGroupsSlice.reducer,
  accesses: accessesSlice.reducer
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
